module.exports = __webpack_public_path__ + "static/media/background_input_1.cfc54271.png";